module.exports = __webpack_public_path__ + "static/media/rns.95da0675.png";